import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import { AvatarProfileImageFragmentDoc } from '../../fragments.generated';
export type ActiveClientFragment = { __typename?: 'ActiveClient', promptUuid?: string | null, courseVersionId?: number | null, moduleVersionId?: string | null, skillVersionId?: string | null, verificationStepId?: string | null, moduleContentMembershipId?: string | null, richTextDocumentId?: string | null, workflowVersionId?: string | null, clientId: string, user: { __typename?: 'Employee', id: number, name: string, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null } };

export const ActiveClientFragmentDoc = gql`
    fragment ActiveClient on ActiveClient {
  promptUuid
  courseVersionId
  moduleVersionId
  skillVersionId
  verificationStepId
  moduleContentMembershipId
  richTextDocumentId
  workflowVersionId
  clientId
  user {
    id
    name
    profileImage {
      ...AvatarProfileImage
    }
  }
}
    ${AvatarProfileImageFragmentDoc}`;